import React from "react";
import { motion } from "framer-motion";
// material
import { Box, SxProps } from "@mui/material";
//
import { varSmallClick, varMediumClick } from "./variants";

interface Props {
  mediumClick?: boolean;
  children?: React.ReactNode;
  sx?: SxProps;
}

export default function ButtonAnimate({
  mediumClick = false,
  children,
  sx,
  ...other
}: Props) {
  return (
    <Box
      component={motion.div}
      whileTap="tap"
      whileHover="hover"
      variants={mediumClick ? varMediumClick : varSmallClick}
      sx={{ display: "inline-flex", ...sx }}
      {...other}
    >
      {children}
    </Box>
  );
}
